import QColorPicker from './src/QColorPicker';

QColorPicker.install = Vue => {
  Vue.component(QColorPicker.name, QColorPicker);
};

export default QColorPicker;
